import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Regel } from '../../models/Regel';
import { RegelsService } from '../../services/regels.service';

@Component({
  selector: 'app-regel-dialog',
  templateUrl: './regel-dialog.component.html',
  styleUrls: ['./regel-dialog.component.scss']
})
export class RegelDialogComponent implements OnInit {
  action: string;
  local_data: any;
  beschikbareRegelTypes: string[];
  karakteristiekNaam: string = '';
  operator: string = '';
  waarde: string = '';
  numeriek: boolean = false;
  brugApprovedTime: string = '';
  lonCoordinaat: string = '';
  latCoordinaat: string = '';
  eenheidStatus: string = '';
  brwKazerne: string = '';
  voertuigSoortCodes: string = '';

  constructor(
    private regelsSvc: RegelsService,
    public dialogRef: MatDialogRef<RegelDialogComponent>,
    //@Optional() is used to prevent error if no data is passed
    @Optional() @Inject(MAT_DIALOG_DATA) public data: Regel
  ) {
    console.log(data);
    this.local_data = { ...data };
    this.action = this.local_data.action;
  }

  ngOnInit(): void {
    this.validateValuesKarakteristiekRegel();
    this.validateValuesBrwPrioriteitRegel();
    this.validateValuesBrugOpeningRegel();
    this.validateValuesEenheidStatusRegel();

    this.regelsSvc.beschikbareRegelTypes().subscribe((t) => {
      this.beschikbareRegelTypes = t;
    });
  }

  doAction() {
    this.validateRuleKarakteristiekRegel();
    this.validateRuleBrwPrioriteitRegel();
    this.validateRuleBrugOpeningRegel();
    this.validateRuleEenheidStatusRegel();

    this.dialogRef.close({ event: this.action, data: this.local_data });
  }

  validateValuesKarakteristiekRegel(): void {
    if (this.local_data.type === 'KarakteristiekRegel') {
      //var str = new String();
      var argsParts: string[] = this.local_data.waardeRegel.split('|');

      if (argsParts.length > 0) {
        this.karakteristiekNaam = argsParts[0];
      }

      if (argsParts.length > 1) {
        this.operator = argsParts[1];
      }
      if (argsParts.length == 4) {
        this.waarde = argsParts[2];
        this.numeriek = argsParts[3] === 'true' ? true : false;
      }

      if (argsParts.length > 4) {
        var argsCount = argsParts.length;
        this.waarde = argsParts.slice(2, argsCount - 1).join('|');
        this.numeriek = argsParts[argsCount - 1] === 'true' ? true : false;
      }
    }
  }
  validateValuesBrwPrioriteitRegel(): void {
    if (this.local_data.type === 'PrioriteitBrwRegel') {
      //var str = new String();
      var argsParts: string[] = this.local_data.waardeRegel.split('|');

      if (argsParts.length > 0) {
        this.operator = argsParts[0];
      }

      if (argsParts.length > 1) {
        this.waarde = argsParts[1];
      }
    }
  }

  validateValuesBrugOpeningRegel(): void {
    if (this.local_data.type === 'BrugOpeningRegel') {
      //var str = new String();
      var argsParts: string[] = this.local_data.waardeRegel.split('|');

      if (argsParts.length > 0) {
        this.brugApprovedTime = argsParts[0];
      }

      if (argsParts.length > 1) {
        var Coords: string[] = argsParts[1].split(',');
        this.latCoordinaat = Coords[0];
        this.lonCoordinaat = Coords[1];
      }
    }
  }
  validateValuesEenheidStatusRegel(): void {
    if (this.local_data.type === 'EenheidStatusRegel') {
      //var str = new String();
      var argsParts: string[] = this.local_data.waardeRegel.split('|');

      if (argsParts.length > 0) {
        this.eenheidStatus = argsParts[0];
      }
      if (argsParts.length > 1) {
        this.brwKazerne = argsParts[1];
      }
      if (argsParts.length > 2) {
        this.voertuigSoortCodes = argsParts[2];
      }
    }
  }

  validateRuleKarakteristiekRegel(): void {
    if (this.local_data.type === 'KarakteristiekRegel') {
      let uitvoer: string = `${this.karakteristiekNaam}|${this.operator}|${this.waarde}|${this.numeriek}`;
      this.local_data.waardeRegel = uitvoer;
    }
  }
  validateRuleBrwPrioriteitRegel(): void {
    if (this.local_data.type === 'PrioriteitBrwRegel') {
      let uitvoer: string = `${this.operator}|${this.waarde}`;
      this.local_data.waardeRegel = uitvoer;
    }
  }
  validateRuleBrugOpeningRegel(): void {
    if (this.local_data.type === 'BrugOpeningRegel') {
      let uitvoer: string = `${this.brugApprovedTime}|${this.latCoordinaat},${this.lonCoordinaat}`;
      this.local_data.waardeRegel = uitvoer;
    }
  }
  validateRuleEenheidStatusRegel(): void {
    if (this.local_data.type === 'EenheidStatusRegel') {
      let uitvoer: string = `${this.eenheidStatus}|${this.brwKazerne}|${this.voertuigSoortCodes}`;
      this.local_data.waardeRegel = uitvoer;
    }
  }

  closeDialog() {
    this.dialogRef.close({ event: 'Annuleren' });
  }
}
